import React from 'react'
import Welcome from './components/common/Welcome'
export const Home = () => {
  return (
    <Welcome/>
  )
}
